// LayerSoloBadge — キャンバス隅の札「N だけを見ています」(長押しで強調中だけ出る、
// layer-thumbnails-2026-10-13.md)。出し入れは engine の onLayerSoloChange だけで決める
// (自分のストローク開始・濃度変更・resize などの自動終了でも消える)。
// この札だけが再レンダーする (キャンバス・パネルは巻き込まない)。
// 「うすく表示中」札 (左上) の下に置く。タッチ・ポインタを奪わない。

import { useEffect, useState } from 'react';

/** 札が要る engine の面 (CanvasDrawingEngine の部分集合)。 */
export interface LayerSoloSource {
  getLayerSolo(): number | null;
  onLayerSoloChange(cb: (layerId: number | null) => void): () => void;
}

export interface LayerSoloBadgeProps {
  readonly engine: LayerSoloSource | null;
}

export const LayerSoloBadge = ({ engine }: LayerSoloBadgeProps): React.ReactNode => {
  const [layerId, setLayerId] = useState<number | null>(null);
  useEffect(() => {
    if (engine === null) {
      setLayerId(null);
      return;
    }
    setLayerId(engine.getLayerSolo());
    return engine.onLayerSoloChange(setLayerId);
  }, [engine]);
  if (layerId === null) return null;
  return (
    <div
      role="status"
      data-testid="layer-solo-badge"
      className="pointer-events-none absolute left-2 top-10 z-10 rounded-full border border-[var(--color-border)] bg-[var(--color-bg-inset)] px-3 py-1 text-xs font-bold text-[var(--color-text-muted)] shadow"
    >
      {layerId + 1} だけを見ています
    </div>
  );
};
